import React from 'react';
import ReactDOM from 'react-dom';
import FilterGroup from './module/filtergroup.jsx';
import Contributions from './module/contributions.jsx';
import xhr from 'xhr';

class AppContributions extends React.Component {
    constructor() {
        super();
        this.onYearChange = this.onYearChange.bind(this);
        this.onTagChange = this.onTagChange.bind(this);
        this.onDataChange = this.onDataChange.bind(this);
        this.state = {
            heading: '',
            description: '',
            tagHeader: '',
            yearHeader: '',
            culture: '',
            year: new Date().getFullYear(),
            tag: '',
            tags: [],
            years: [],
            contributions: []
        };
    }

    componentDidMount() {
        this.getAwards(this.onDataChange);
    }

    getAwards(cb) {
        var query = `/umbraco/api/awards/getbytag?id=${this.props.id}&year=${encodeURIComponent(this.state.year)}&tag=${encodeURIComponent(this.state.tag)}&culture=${encodeURIComponent(this.props.culture)}`;

        return this.async(query, cb);
    }

    async(uri, cb) {
        xhr({
            body: '',
            uri: uri,
            headers: {
                "Content-Type": "application/json"
            }
        }, cb);
    }

    onYearChange(year) {
        this.setState({ year: year }, () => this.getAwards(this.onDataChange));
    }

    onTagChange(tag) {
        this.setState({ tag: tag }, () => this.getAwards(this.onDataChange));
    }

    onDataChange(err, resp, body) {
        let result = this.getContributionsData(body);
        let tagKeys = {};

        result.tags = result.tags.filter((value, index, self) => {
            if (tagKeys.hasOwnProperty(value.key)) {
                return false;
            } else {
                tagKeys[value.key] = value.value;
                return true;
            }
        }); // dedupe tags

        this.setState({
            heading: result.heading,
            description: result.description,
            tagHeader: result.tagHeader,
            yearHeader: result.yearHeader,
            year: result.year,
            tag: result.tag,
            tags: result.tags,
            years: result.years,
            contributions: result.contributions
        }, () => {
            if (this.state.contributions.length) return;

            let year = this.getAvailableYear(this.state.year, this.state.years);
            if (!year) return;

            this.onYearChange(year);
        });
    }

    render() {
        return (
            <div className="comp__project-list" data-sr="enter bottom, move 20px,opacity 0.3, scale 0.8, reset, vFactor 0.2">
                <FilterGroup 
                    onYear={this.onYearChange} 
                    onTag={this.onTagChange} 
                    years={this.state.years} 
                    tags={this.state.tags} 
                    tagHeader={this.state.tagHeader} 
                    yearHeader={this.state.yearHeader} />
                <Contributions contributions={this.state.contributions} />
            </div>
        );
    }

    getAvailableYear(currentYear, years) {
        // Ensure that we are getting contributions in bounds of available years
        let sortedYears = this.sortYearsDescending(years);

        if (currentYear === sortedYears[sortedYears.length - 1]) {
            // nowhere to search
            return null;
        }

        for (let i = 0; i < sortedYears.length; i++) {
            if (currentYear > sortedYears[i]) {
                return sortedYears[i];
            }
        }

        return null;
    }

    sortYearsDescending(years) {
        return years.slice(0).sort((a, b) => b - a);
    }

    getContributionsData(responseBody) {
        if (!responseBody) {
            throw new Error("Can't get awards from API");
        }

        try {
            return JSON.parse(responseBody);
        } catch (e) {
            throw new Error("Can't parse response from API");
        }
    }
};

(function () {
    let id = document.getElementById("awards").value;
    let culture = document.getElementById("culture").value;
    ReactDOM.render(<AppContributions id={id} culture={culture} />, document.getElementsByClassName("comp__project-list")[0]);
}());



// WEBPACK FOOTER //
// ./app/js/contributions.jsx